import { axios } from '@/utils/request'
const api = {
  source: '/finance/customerStatement',
  remove:'/finance/customerStatement/majorStatement'
}
export function getSourceList (parameter) {
  return axios({
    url: api.source + '/list',
    method: 'get',
    params: parameter
  })
}
export function getexportList (parameter) {
  return axios({
    url: '/finance/customerStatement/export',
    method: 'get',
    params: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  })
}
export function getSettleList (parameter) {
  return axios({
    url: api.source + '/settleList',
    method: 'get',
    params: parameter
  })
}
export function applyCancel (parameter) {
  return axios({
    url:  '/finance/customerStatement/applyCancel',
    method: 'get',
    params: parameter
  })
}
export function apply (parameter) {
  return axios({
    url:  '/finance/customerStatement/apply',
    method: 'get',
    params: parameter
  })
}
export function invoice (parameter) {
  return axios({
    url: '/finance/customerStatement/invoice',
    method: 'post',
    params: parameter,
  })
}
export function invoiceCancel (parameter) {
  return axios({
    url: '/finance/customerStatement/invoiceCancel',
    method: 'post',
    params: parameter,
  })
}
// 主菜单的批量结算按钮
export function getmajorSettleList (parameter) {
  return axios({
    url: api.source + '/majorSettleList',
    method: 'get',
    params: parameter
  })
}
export function removeSettleList (parameter) {
  return axios({
    url: api.remove + '/remove',
    method: 'GET',
    params: parameter
  })
}
export function getEditList (parameter) {
  return axios({
    url: api.source + '/detail',
    method: 'get',
    params: parameter
  })
}
export const sourceExport = api.source + '/export'